import { get } from "lodash";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { huyi } from "~/utils/clog";
import { TypeAction } from "~/utils/constants";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";
import * as actions from "./hospitalActions";
import * as api from "./hospitalAPIs";
import * as types from "./hospitalTypes";

const loadedHospitalListByFeatureId = {};

function* requestHospitalList({
  keyword,
  city_id,
  city_id_v2,
  ward_id,
  ward_id_v2,
  newHospitalType,
  page,
  limit,
  isHis,
  type_search
}) {
  try {
    yield put(actions.loadingHospitalList());

    const global = yield select(state => state.global);
    const total = yield select(state => state.totalData);
    const user = yield select(state => state.user);

    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const finalParams = {
      keyword: keyword || "",
      page: page || 1,
      limit: limit || 100,
      city_id: city_id,
      city_id_v2: city_id_v2,
      ward_id: ward_id,
      ward_id_v2: ward_id_v2,
      newHospitalType: newHospitalType,
      type: type_search
    };

    if (isHis || total.typeAction === TypeAction.DaTungKham) {
      const response = yield client.getHospitalListHaveHisCskhV7(finalParams, {
        platform,
        appid: AppId,
        token: user?.info?.token || ""
      });
      const resData = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      const total =
        response.data?.count || response.data?.total || resData.length;
      yield put(actions.requestHospitalListSuccess(resData, total));
    } else {
      const response = yield client.getHospitalListByAppIdV7(finalParams, {
        platform,
        appid: AppId,
        token: user?.info?.token || ""
      });
      const resData = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      const total =
        response.data?.count || response.data?.total || resData.length;
      yield put(actions.requestHospitalListSuccess(resData, total));
    }

    // Removed yield put(offLoading());
  } catch (error) {
    // Removed yield put(offLoading());

    huyi({ name: "getHospitalListV7", child: error, type: 0 });
    yield put(actions.requestHospitalListFail(error));
  }
}

function* hospitalListWatcher() {
  yield takeEvery(types.REQUEST_HOSPITAL_LIST, requestHospitalList);
}

function* requestHospitalListByFeatureId({ id }) {
  if (!loadedHospitalListByFeatureId[id]) {
    try {
      yield put(actions.loadingHospitalListByFeatureId(id));
      const response = yield call(api.requestHospitalListByFeatureId, id);
      const { data } = response;
      if (data.error_code)
        throw Error(`Loading hospital list by feature id ${id} fail!`);
      yield put(actions.requestHospitalListByFeatureIdSuccess(id, data));
      loadedHospitalListByFeatureId[id] = true;
    } catch (error) {
      yield put(actions.requestHospitalListByFeatureIdFail(id, error));
    }
  }
}

function* requestFeatureByHospitalId({ id }) {
  try {
    // yield put(actions.loadingHospitalListByFeatureId(id));
    const response = yield call(api.requestFeatureByHospitalId, id);
    const { data } = response;
    if (data.error_code)
      throw Error(`Loading feature list by hosital id ${id} fail!`);
    yield put(actions.requestFeatureByHospitalIdSuccess(id, data));
    loadedHospitalListByFeatureId[id] = true;
  } catch (error) {
    yield put(actions.requestFeatureByHospitalIdFail(id, error));
  }
}

function* hospitalListByFeatureIdWatcher() {
  yield takeEvery(
    types.REQUEST_HOSPITAL_LIST_BY_FEATURE_ID,
    requestHospitalListByFeatureId
  );
  yield takeEvery(
    types.REQUEST_FEATURE_LIST_BY_HOSPITAL_ID,
    requestFeatureByHospitalId
  );
}

export default function* root() {
  yield all([call(hospitalListWatcher), call(hospitalListByFeatureIdWatcher)]);
}
